import React from "react";
import PropTypes from "prop-types";
import ModalApp from "../ModalApp";
import LockIcon from "../../assets/padlock.svg";

export default function FixedAddressModal({ show, onClose }) {
  return (
    <ModalApp show={show} handleModal={onClose}>
      <div style={{ textAlign: "center", padding: "0px 16px" }}>
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "#F0F0FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <img src={LockIcon} alt="" width={24} height={24} />
        </div>
        <h3
          style={{
            fontSize: 16,
            fontWeight: 700,
            marginBottom: 12,
            color: "#1a1a1a",
          }}
        >
          Este endereço não pode ser alterado.
        </h3>
        <p
          style={{
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "150%",
            color: "#555",
            margin: 0,
          }}
        >
          Por questões cadastrais, ele não pode ser alterado nesta plataforma.
          Caso precise atualizá-lo, faça a alteração diretamente na plataforma
          principal. Após a atualização, o novo endereço será refletido aqui
          automaticamente.
        </p>
      </div>
    </ModalApp>
  );
}

FixedAddressModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};
